// Operator contact-submission detail strings (auto-merged by lib/i18n.ts).
export const en = {
  'operator.contact_submission_detail.head': 'Contact from {name}',
  'operator.contact_submission_detail.back': 'Back to contact form',
  'operator.contact_submission_detail.message': 'Message',
  'operator.contact_submission_detail.contact': 'Contact',
  'operator.contact_submission_detail.email': 'Email',
  'operator.contact_submission_detail.phone': 'Phone',
  'operator.contact_submission_detail.company': 'Company',
  'operator.contact_submission_detail.received': 'Received',
}

export const zhTW = {
  'operator.contact_submission_detail.head': '{name} 的聯絡訊息',
  'operator.contact_submission_detail.back': '返回聯絡表單',
  'operator.contact_submission_detail.message': '訊息內容',
  'operator.contact_submission_detail.contact': '聯絡資料',
  'operator.contact_submission_detail.email': '電子郵件',
  'operator.contact_submission_detail.phone': '電話',
  'operator.contact_submission_detail.company': '公司',
  'operator.contact_submission_detail.received': '收到時間',
}
